import React from 'react'
import SbEditable from 'storyblok-react'
import TextRenderer from '../TextRenderer'
import ButtonPrimary from '../ButtonPrimary'

import styles from './styles.module.scss'

const TitleWithButton = (props) => {
	return (
		<SbEditable content={props.blok}>
			<section className={styles['title-with-button']}>
                <div className='container'>
                    <div className={`row ${styles['title-with-button__row']}`}>
                        <div className='col col-12 col-sm-5'>
                            <TextRenderer className={styles['title-with-button__heading']} text={props.blok.heading}/>
                            {props.blok.button && props.blok.button.map(blok => {
                                return (
                                    <SbEditable content={blok} key={blok._uid}>
                                        <ButtonPrimary label={blok.label} link={blok.link} size={blok.size} />
                                    </SbEditable>
                                )
                            })}
                        </div>
                        <div className={`col col-12 col-sm-7 ${styles['title-with-button__description']}`}>
                            <TextRenderer className={`text`} text={props.blok.description} />
                        </div>
                    </div>
                </div>
            </section>
		</SbEditable>
	)
}

export default TitleWithButton